import React, { useContext } from "react";
import { ongoingProjects } from "../../../portfolio";
import StyleContext from "../../../contexts/StyleContext";
import "./ArenaLabProjects.css";

export default function ArenaLabProjects() {
  const { isDark } = useContext(StyleContext);

  return (
    <div className="arena-lab-section projects-section" id="lab-projects">
      <h2 className="section-title">Ongoing Projects</h2>
      <p className="projects-intro">
        Discover the cutting-edge research projects we're currently developing. Join us and contribute to advancing embodied AI and robotics.
      </p>
      
      <div className="projects-grid">
        {ongoingProjects.projects.map((project, index) => (
          <div key={index} className={`project-card ${isDark ? "dark-mode" : ""}`}>
            <div className="project-image-wrapper">
              <img 
                src={project.image} 
                alt={project.projectName}
                className="project-image"
              />
              <div className="project-image-overlay"></div>
            </div>
            
            <div className="project-content">
              <h3 className="project-name">{project.projectName}</h3>
              
              <p className="project-desc">{project.projectDesc}</p>
              
              {project.skills && project.skills.length > 0 && (
                <div className="project-skills">
                  {project.skills.map((skill, i) => (
                    <span key={i} className="skill-tag">{skill}</span>
                  ))}
                </div>
              )}
              
              {project.footerLink && project.footerLink.length > 0 && (
                <div className="project-links">
                  {project.footerLink.map((link, i) => (
                    link.url && (
                      <a
                        key={i}
                        href={link.url}
                        className={`project-link ${i === 0 ? "primary" : "secondary"}`}
                        target={link.url.startsWith("http") ? "_blank" : "_self"}
                        rel={link.url.startsWith("http") ? "noreferrer" : undefined}
                      >
                        {link.name}
                      </a>
                    )
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
